import { MarkerClusterer } from '@googlemaps/markerclusterer';

export interface MarkerProps extends google.maps.MarkerOptions {
  marker: Marker;
  onClick: (markerId: Marker['id'], mapMarker: google.maps.Marker) => void;
}

export interface MapComponentProps {
  map?: google.maps.Map;
  center: google.maps.LatLngLiteral;
  zoom?: number;
  mapTypeId: google.maps.MapTypeId | string;
  onMapClick?: (position: google.maps.LatLng | null) => void;
  setMap: React.Dispatch<React.SetStateAction<google.maps.Map | undefined>>;
}

export interface MapProps {
  apiKey: string;
  zoom?: number;
  center: google.maps.LatLngLiteral;
  mapTypeId: google.maps.MapTypeId | string;
  markers: Marker[];
  hasFilter?: boolean;
  selectedMarkerTypes?: MarkerType[];
  markerAllTypes: MarkerType[];
  setSelectedMarkerTypes?: (markerTypes: MarkerType[]) => void;
  onMapClick?: (position: google.maps.LatLng | null) => void;
  onFilterChange?: (markerTypes: MarkerType[]) => void;
}

export interface Marker {
  id: string;
  icon: string | google.maps.Icon | google.maps.Symbol;
  position: google.maps.LatLng | google.maps.LatLngLiteral;
  markerType: MarkerType;
  onClick?: (markerId: Marker['id'], mapMarker: google.maps.Marker) => void;
  infoWindowContent?: JSX.Element;
  locationDescription?: string;
  displayIdentifier?: string;
}

export interface MarkerExt {
  marker: google.maps.Marker;
  type: MarkerType;
}
export interface MarkerClustererExt {
  markerClusterer: MarkerClusterer;
  type: MarkerType;
}

export enum MarkerType {
  PIPING = 'PIPING',
  STEEL = 'STEEL',
  ROD_ROOM = 'ROD_ROOM',
  DATA_VAULT = 'DATA_VAULT',
}

export interface MarkerFilter {
  label: string;
  value: MarkerType;
  icon: string;
}
